module.exports = __webpack_public_path__ + "static/img-main-6cb50ce703e9416c3a60da8278f3ff8a.png";